import { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';

export const useJudgesSync = () => {
  const [judges, setJudges] = useState([]);
  const location = useLocation();

  useEffect(() => {
    const syncJudgesFromStorage = () => {
      const raw = localStorage.getItem('judges');
      if (raw) {
        try {
          setJudges(JSON.parse(raw));
        } catch {
          /* ignore */
        }
      }
    };
    syncJudgesFromStorage();
    window.addEventListener('judges-localstorage-updated', syncJudgesFromStorage);
    return () => window.removeEventListener('judges-localstorage-updated', syncJudgesFromStorage);
  }, [location.pathname]);

  // setJudges + localStorage + custom event'i tek çağrıya düşüren commit yardımcısı.
  // 4 yerdeki "setJudges → localStorage.setItem → dispatchEvent" zincirini birleştirir.
  const commitJudges = useCallback((updatedJudges) => {
    setJudges(updatedJudges);
    localStorage.setItem('judges', JSON.stringify(updatedJudges));
    window.dispatchEvent(new Event('judges-localstorage-updated'));
  }, []);

  return { judges, setJudges, commitJudges };
};
